import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { sendErrorNotification } from "../../../../universal/notifications/notifications";
import { ToastContainer } from "react-toastify";
import {
  changePipelineModal,
  requestUpdatePipelineUnit,
} from "../../../../../redux/actions/pipeline";
import { TransparentButton, SolidButton } from "../../../../library/button";
import { Input } from "../../../../library/input";
import { Textarea } from "../../../../library/textarea";
import { Popup } from "../../../../library/popup";
import { Label } from "../../../../library/label";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const modalState = useSelector(
    (state) => state.pipeline.showModals.editUnitPipelineModal
  );
  const activeUnit = useSelector(
    (state) => state.pipeline && state.pipeline.activeUnit
  );

  const companyId = useSelector(
    (state) => state.activeCompany.activeCompany.id
  );

  const pipelineId = useSelector(
    (state) => state.pipeline.activePipeline && state.pipeline.activePipeline.id
  );

  const loading = useSelector((state) => state.pipeline.updateUnit.loading);

  const [activeUnitObject, setActiveUnitObject] = useState({});

  const handleClose = () => {
    dispatch(changePipelineModal({ editUnitPipelineModal: false }));
  };

  const clickUpdateOpportunity = () => {
    if (activeUnitObject && activeUnitObject.title && activeUnitObject.amount) {
      dispatch(
        requestUpdatePipelineUnit({
          companyId: companyId,
          unit: activeUnitObject,
          pipelineId: pipelineId,
          type: activeUnitObject.type,
        })
      );
    } else {
      sendErrorNotification("Du må oppgi en tittel og et beløp.");
    }
  };

  useEffect(() => {
    if (Object.keys(activeUnit).length > 0) {
      setActiveUnitObject(activeUnit);
    }
  }, [activeUnit]);

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Endre mulighet"
      buttons={[
        <TransparentButton
          title="Avbryt"
          id="closeButtonAdd"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        <SolidButton
          color="blue"
          title={loading ? "Oppdaterer.." : "Oppdater"}
          icon={
            loading ? <i className="fas fa-circle-notch fa-spin"></i> : null
          }
          onClick={() => clickUpdateOpportunity()}
          type="button"
        />,
      ]}
    >
      <div className="edit-unit-content-container">
        <div className="new-event-container">
          <Row className="info-row">
            <Col className="info-col">
              <Label version={1} weight="bold">
                Tittel
              </Label>
              <Input
                value={activeUnitObject.title}
                onChange={(e) =>
                  setActiveUnitObject({
                    ...activeUnitObject,
                    title: e.target.value,
                  })
                }
                placeholder="Mitt produkt"
                type="text"
              />
            </Col>
          </Row>
          <Row className="info-row">
            <Col className="info-col">
              <Label version={1} weight="bold">
                Beløp
              </Label>
              <Input
                format="amount"
                value={activeUnitObject.amount}
                onChange={(e) =>
                  setActiveUnitObject({
                    ...activeUnitObject,
                    amount: e.target.value,
                  })
                }
                placeholder="10 000"
              />
            </Col>
          </Row>
          <Row className="info-row">
            <Col className="info-col">
              <Label version={1} weight="bold">
                Beskrivelse
              </Label>
              <Textarea
                value={activeUnitObject.description}
                onChange={(e) =>
                  setActiveUnitObject({
                    ...activeUnitObject,
                    description: e.target.value,
                  })
                }
                rows={3}
                placeholder="Beskrivelse av produktet du selger."
              />
            </Col>
          </Row>
          {activeUnitObject &&
          Object.keys(activeUnitObject).length > 0 &&
          activeUnitObject.type === "company" ? (
            <Row className="info-row">
              <Col className="info-col">
                <Label version={1} weight="bold">
                  Kontaktperson
                </Label>
                <Input
                  value={activeUnitObject.contactPerson}
                  onChange={(e) =>
                    setActiveUnitObject({
                      ...activeUnitObject,
                      contactPerson: e.target.value,
                    })
                  }
                  placeholder="Gavin Belson"
                  type="text"
                />
              </Col>
            </Row>
          ) : null}
        </div>
      </div>
      <ToastContainer />
    </Popup>
  );
};

export default Index;
